
import { Buffer } from './e.m.c.a.404.types';

/**
 *
 * @brief specification for the various events we expect to be visible
 * within the parser and to the application.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2023
 *
 */

export enum EventType {

  BUFFER_COMPLETED = 'buffer_completed',
  WARNING          = 'warning',
  ERROR            = 'error'
}

/*
 * - - - - - - - - - - - - - - - - - - - - - - - - - -
 *
 * EVENTS
 *
 * - - - - - - - - - - - - - - - - - - - - - - - - - -
 */

/** Common base interface for all events */
export interface ParserEvent {

  /** symbolic / kind of event */
  tag: string;

  /** all events have a unique id */
  id: number;

  /** the event data */
  data: any;

}

/*
 * - - - - - - - - - - - - - - - - - - - - - - - - - -
 *
 * CALLBACKS
 *
 * - - - - - - - - - - - - - - - - - - - - - - - - - -
 */

export type ParserErrorCallback     = (event: ParserEvent) => void;
export type ParserWarningCallback   = (event: ParserEvent) => void;
export type BufferCompletedCallback = (event: ParserEvent) => void;
export type Listener                = (data: Buffer, index: string|number|undefined)       => void;
